import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  throw new Error("Configure VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY no .env");
}

export const supabase = createClient(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: "aferi.auth",
  },
  db: { schema: "aferi" as any },
  global: {
    headers: { "X-Client-Info": "prosper-v2" },
  },
  realtime: {
    params: { eventsPerSecond: 5 },
  },
});

/** Helper para chamar RPCs com tipagem futura */
export async function rpc<T = unknown>(fn: string, args?: Record<string, any>): Promise<T> {
  const { data, error } = await supabase.rpc(fn, args);
  if (error) throw error;
  return data as T;
}

/** URL do edge function deste projeto */
export function edgeUrl(name: string): string {
  return `${url}/functions/v1/${name}`;
}

export const anonKey = key as string;

/** Headers autenticados para chamar edge functions (Authorization + apikey) */
export async function edgeHeaders(extra: Record<string, string> = {}): Promise<Record<string, string>> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token ?? key;
  return { Authorization: `Bearer ${token}`, apikey: key as string, ...extra };
}
